import React from 'react';
import { injectIntl } from '../../Utils/reactIntlCompat';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import DatePicker from '../Inputs/DbeDatePicker';
import { useFieldRequired } from './fieldRequiredContext';

const FormDatePicker = function FormDatePicker({
  name,
  intl,
  defaultValue = null,
  required = false,
  width = '100%',
  error = null,
  minDate = null,
  maxDate = null,
}) {
  const { control, clearErrors } = useFormContext();
  const { message = null } = error || {};
  const effectiveRequired = useFieldRequired(required);
  const nameTranslation = Object.prototype.hasOwnProperty.call(
    intl.messages,
    name?.toUpperCase()
  )
    ? intl.messages[name.toUpperCase()]
    : null;

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: {
          value: effectiveRequired,
          message: intl.messages.MANDATORY_FIELD,
        },
      }}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          inputFormat={intl.messages.INPUT_DATE_FORMAT}
          onChange={(e) => {
            clearErrors(name);
            onChange(e);
          }}
          date={value}
          variant="outlined"
          label={nameTranslation}
          required={effectiveRequired}
          fullWidth={width === '100%'}
          helperText={message || ' '}
          FormHelperTextProps={{
            sx: {
              whiteSpace: 'noWrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          error={error}
          sx={{
            width: width !== '100%' ? width : null,
            '& .MuiInputBase-input': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          size="outlined"
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    />
  );
};

FormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.object,
  required: PropTypes.bool,
  width: PropTypes.string,
  intl: PropTypes.object.isRequired,
  error: PropTypes.object,
};
export default injectIntl(FormDatePicker);
